/* eslint-disable max-len */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable sonarjs/no-duplicate-string */

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { checkPermisson } from '../../../selectors/common';
import MarketSettingsTable from './MarketSettingsTable';

const mapToProps = (state) => ({
  checkPermisson: (payload) => checkPermisson(state, payload),
});
class MarketSettings extends Component {
  constructor(props) {
    super(props);

    this.state = {
      marketSettings: [],
      oddsDropDown: null,
      resultsDropDown: null,
      oddsDisabledStatusState: null,
      previousOddsDisabledStatusState: null,
      resultsDisabledStatusState: null,
      previousResultsDisabledStatusState: null,
    };
  }

  componentDidMount() {
    this.props.getMarketSettings();
  }

  componentDidUpdate() {
    if (this.state.marketSettings.length === 0 && this.props.marketSettings.length !== 0) {
      this.setState({
        marketSettings: this.props.marketSettings,
      });
    }
  }

  componentWillUnmount() {
    this.props.clearMarketSettings();
  }

  toggleOddsDropdownState = (id) => {
    this.setState({
      oddsDropDown: this.state.oddsDropDown ? null : id,
    });
  };

  toggleResultsDropdownState = (id) => {
    this.setState({
      resultsDropDown: this.state.resultsDropDown ? null : id,
    });
  };

  toggleDisableOddsStatusState = (id) => {
    const currentOddsState = this.state.marketSettings.find((m) => m.id === id)?.oddsDisabled;
    this.setState({
      oddsDisabledStatusState: id,
      resultsDropDown: null,
      previousOddsDisabledStatusState: currentOddsState,
    });
  };

  toggleDisableResultsStatusState = (id) => {
    const currentResultsStatusState = this.state.marketSettings.find((m) => m.id === id)?.resultsDisabled;
    this.setState({
      resultsDisabledStatusState: id,
      oddsDropDown: null,
      previousResultsDisabledStatusState: currentResultsStatusState,
    });
  };

  handleOddsStatus = (marketId, newOddsState) => {
    const currentMarketSettings = [...this.state.marketSettings];
    const marketIndex = this.state.marketSettings.findIndex((m) => m.id === marketId);
    currentMarketSettings[marketIndex].oddsDisabled = newOddsState;

    this.setState({
      marketSettings: currentMarketSettings,
      oddsDropDown: null,
    });
  };

  handleResultsStatus = (marketId, newResultsState) => {
    const currentMarketSettings = [...this.state.marketSettings];
    const marketIndex = this.state.marketSettings.findIndex((m) => m.id === marketId);
    currentMarketSettings[marketIndex].resultsDisabled = newResultsState;

    this.setState({
      marketSettings: currentMarketSettings,
      resultsDropDown: null,
    });
  };

  closeConfirmationBtns = () => {
    const currentMarketSettings = this.state.marketSettings.map((m) => ({ ...m }));
    if (this.state.oddsDisabledStatusState) {
      const marketIndex = this.state.marketSettings.findIndex((m) => m.id === this.state.oddsDisabledStatusState);
      currentMarketSettings[marketIndex].oddsDisabled = this.state.previousOddsDisabledStatusState;
      this.setState({
        oddsDisabledStatusState: null,
        oddsDropDown: null,
        marketSettings: currentMarketSettings,
        previousOddsDisabledStatusState: null,
      });
    } else if (this.state.resultsDisabledStatusState) {
      const marketIndex = this.state.marketSettings.findIndex((m) => m.id === this.state.resultsDisabledStatusState);
      currentMarketSettings[marketIndex].resultsDisabled = this.state.previousResultsDisabledStatusState;
      this.setState({
        resultsDisabledStatusState: null,
        resultsDropDown: null,
        marketSettings: currentMarketSettings,
        previousResultsDisabledStatusState: null,
      });
    }
  };

  requestForUpdate = () => {
    if (this.state.oddsDisabledStatusState) {
      const updatedOddsDisabledState = this.state.marketSettings.find((m) => m.id === this.state.oddsDisabledStatusState)?.oddsDisabled;
      this.props.updateOddsDisable({
        mainMarketId: this.state.oddsDisabledStatusState,
        status: updatedOddsDisabledState,
      });
    } else if (this.state.resultsDisabledStatusState) {
      const updatedResultsStatusState = this.state.marketSettings.find((m) => m.id === this.state.resultsDisabledStatusState)?.resultsDisabled;
      this.props.updateResultsDisable({
        mainMarketId: this.state.resultsDisabledStatusState,
        status: updatedResultsStatusState,
      });
    }

    this.setState({
      oddsDropDown: null,
      resultsDropDown: null,
      oddsDisabledStatusState: null,
      resultsDisabledStatusState: null,
      previousOddsDisabledStatusState: null,
      previousResultsDisabledStatusState: null,
    });
  };

  render() {
    return (
      <div className="table-wrapper m-t-30">
        <div className="table-responsive fix-odd">
          <table className="table-style table-style--setting">
            <thead>
              <tr>
                <th>Markets</th>
                <th>Odds</th>
                <th>Results</th>
                <th />
              </tr>
            </thead>
            <tbody>
              <MarketSettingsTable
                marketSettings={this.state.marketSettings}
                oddsDisabledStatusState={this.state.oddsDisabledStatusState}
                resultsDisabledStatusState={this.state.resultsDisabledStatusState}
                oddsDropDown={this.state.oddsDropDown}
                toggleOddsDropdownState={this.toggleOddsDropdownState}
                handleOddsStatus={this.handleOddsStatus}
                resultsDropDown={this.state.resultsDropDown}
                toggleResultsDropdownState={this.toggleResultsDropdownState}
                handleResultsStatus={this.handleResultsStatus}
                checkPermisson={this.props.checkPermisson}
                toggleDisableOddsStatusState={this.toggleDisableOddsStatusState}
                requestForUpdate={this.requestForUpdate}
                closeConfirmationBtns={this.closeConfirmationBtns}
                toggleDisableResultsStatusState={this.toggleDisableResultsStatusState}
                oddsDisableEnableMarketPermission={this.props.oddsDisableEnableMarketPermission}
                resultsDisableEnableMarketPermission={this.props.resultsDisableEnableMarketPermission}
              />
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}

export default connect(mapToProps)(MarketSettings);
